import React, { Component } from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-fetch';
import queryString from 'query-string';
import $ from 'jquery';

import Loader from '../components/Loader';
import NewsEventsModuleContext from '../context/NewsEventsModuleContext';

const filterDuplicates = (arr) => {
  const seen = new Set();
  return arr.filter((el) => {
    const dups = seen.has(el.nid[0].value);
    seen.add(el.nid[0].value);
    return !dups;
  });
};

const sortByDate = (arr) => {
  arr.sort((a, b) => {
    const typeA = a.type[0].target_id === 'event';
    const typeB = b.type[0].target_id === 'event';
    let dateA = new Date(a.changed[0].value);
    let dateB = new Date(b.changed[0].value);

    if ((typeA && typeof a.field_event_start_date[0] !== 'undefined') && (typeB && typeof b.field_event_start_date[0] !== 'undefined')) {
      dateA = new Date(a.field_event_start_date[0].value);
      dateB = new Date(b.field_event_start_date[0].value);
    }

    return dateB - dateA;
  });

  return arr;
};

export default class NewsEventsModuleContainer extends Component {
  constructor() {
    super();
    this.state = {
      data: [],
      terms: [],
      random: '',
      ready: false,
      filter: 'all',
      offset: 0,
      loadMore: (e) => { this.loadMore(e); },
      loadRandom: (e) => { this.loadRandom(e) }
    };

    this.fetchData = this.fetchData.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.loadRandom = this.loadRandom.bind(this);
  }

  componentDidMount() {
    this.fetchData('initial');
  }

  loadMore(e) {
    e.preventDefault();
    let { offset } = this.state;

    this.setState({
      offset: offset += 5,
    });

    setTimeout(() => {
      this.fetchData('loadMore');
    }, 500);
  }

  loadRandom(e) {
    e.preventDefault();
    const { random } = this.state;
    window.location.href = `${random}`;
  }


  async fetchData(type) {
    const {
      discipline, search, eventLocation, classYear, offset,
      filter, eventDateRangeStart, eventDateRangeEnd, data,
    } = this.state;
    const btnLoadMore = document.querySelector('.btn-load-more');
    const offsetParam = `&offset=${offset}`;

    const apiEventsFuture = `/api/future_events?_format=json${offsetParam}`;
    const apiEventsPast = `/api/past_events?_format=json${offsetParam}`;
    const apiNews = `/api/news?_format=json${offsetParam}`;
    const apiFeatured = `/api/featured?_format=json`;
    const apiTerms = '/api/terms?_format=json';
    // Using random number for cachebusting
    const randomNumber = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    const apiRandom = `/api/random?_format=json&${randomNumber}`;

    const randomize = arr => {
      const newArr= arr.slice();

      for (let i = newArr.length - 1; i > 0; i--) {
        const random = Math.floor(Math.random() * (i + 1));
        [newArr[i], newArr[random]] = [newArr[random], newArr[i]];
      }
      return newArr;
    };

    if (type === 'initial') {
      try {
        const fetchFeatured = await fetch(apiFeatured);
        const fetchNews = await fetch(apiNews);
        const fetchEventsFuture = await fetch(apiEventsFuture);
        const fetchEventsPast = await fetch(apiEventsPast);
        const fetchTerms = await fetch(apiTerms);
        const fetchRandom = await fetch(apiRandom);

        if (!fetchFeatured.ok) {
          throw Error(fetchFeatured.statusText);
        }
        if (!fetchNews.ok) {
          throw Error(fetchNews.statusText);
        }
        if (!fetchEventsFuture.ok) {
          throw Error(fetchEventsFuture.statusText);
        }
        if (!fetchEventsPast.ok) {
          throw Error(fetchEventsPast.statusText);
        }
        if (!fetchTerms.ok) {
          throw Error(fetchTerms.statusText);
        }
        if (!fetchRandom.ok) {
          throw Error(fetchRandom.statusText);
        }
        const featured = await fetchFeatured.json();
        const news = await fetchNews.json();
        const eventsFuture = await fetchEventsFuture.json();
        const eventsPast = await fetchEventsPast.json();
        const events = eventsFuture.concat(eventsPast);
        const newsEvents = news.concat(eventsFuture, eventsPast);
        const sortedNewsEvents = sortByDate(newsEvents);
        const terms = await fetchTerms.json();
        const random = await fetchRandom.json();
        const randomwNewsEvents = randomize(newsEvents);
        const featuredNewsEvents = filterDuplicates([ ...featured.concat(randomwNewsEvents) ]);
        const featuredNews = filterDuplicates([ ...featured.concat(news) ]);
        const featuredEvents = filterDuplicates([ ...featured.concat(events) ]);

        if (filter === 'all') {
          this.setState({ data: featuredNewsEvents });
        }

        this.setState({
          terms,
          random: random[0].view_node,
          ready: true,
        });
      } catch (error) {
        console.log(error);
      }
    } else if (type === 'loadMore') {
      if (filter === 'all') {
        try {
          const fetchNews = await fetch(apiNews);
          const fetchEventsFuture = await fetch(apiEventsFuture);
          const fetchEventsPast = await fetch(apiEventsPast);

          if (!fetchNews.ok) {
            throw Error(fetchNews.statusText);
          }
          if (!fetchEventsFuture.ok) {
            throw Error(fetchEventsFuture.statusText);
          }
          if (!fetchEventsPast.ok) {
            throw Error(fetchEventsPast.statusText);
          }

          const news = await fetchNews.json();
          const eventsFuture = await fetchEventsFuture.json();
          const eventsPast = await fetchEventsPast.json();
          const newsEvents = news.concat(eventsFuture, eventsPast);
          const sortedNewsEvents = sortByDate(newsEvents);
          const filteredNewsEvents = filterDuplicates([...data, ...data.concat(sortedNewsEvents)]);

          if (news.length < 5 && eventsFuture.length < 5 && eventsPast.length < 5) {
            btnLoadMore.classList.add('is-hidden');
          }

          this.setState({ data: filteredNewsEvents });
        } catch (error) {
          console.log(error);
        }
      }
    }
  }

  render() {
    const { ready } = this.state;
    const { children } = this.props;

    if (!ready) return <Loader module />;
    return (
      <NewsEventsModuleContext.Provider value={this.state}>
        {children}
      </NewsEventsModuleContext.Provider>
    );
  }
}

NewsEventsModuleContainer.propTypes = {
  children: PropTypes.shape({}).isRequired,
};
